// controllers
import ResizeController from '../../assets/js/controllers/resize';

// constants
import Platform from '../../assets/js/constants/platform';

// helpers
import { validateParamBoolean } from '../../assets/js/helpers';

export default class HeightMatch {

	static selector = '[data-height-match]';

	// class variables

	el = {};

	config = {
		default: -1,
		isMobileEnabled: false
	};

	controllers = {
		resize: null
	};

	states = {
		heightMaps: {},
		platform: Platform.DESKTOP
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			targets: [],
		};

		this.config.isMobileEnabled = validateParamBoolean(this.el.container, 'data-height-match-mobile');

		this.initialize();
	}

	// init

	initialize() {
		this.gather();

		this.#addEventListeners();
		this.#tick();
	}

	// event listeners

	#addEventListeners = () => {
		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		ResizeController.clear(this.controllers.resize);
	}

	// controller methods

	#onResizeUpdate = () => {
		this.measure();
		return true;
	}

	#onResizeRender = () => {
		this.render();
	}

	//

	#tick = () => {
		this.measure();
		this.render();
	}

	//

	measure() {
		this.states.platform = ResizeController.platform;
	}

	render() {
		if (!this.config.isMobileEnabled && this.states.platform !== Platform.DESKTOP) {
			this.removeStyles();
		} else {

			// reset height to measure
			for (let i = 0; i < this.el.targets.length; i++) {
				const $target = this.el.targets[i];
				$target.style.height = '';
			}

			// iterate through different types of maps
			for (const mapKey in this.states.heightMaps) {
				const map = this.states.heightMaps[mapKey];
				let heightMax = 0;

				// store height of targets
				for (const entry of map) {
					const $target = entry[0];
					map.set($target, parseInt($target.offsetHeight));
				}

				// compare heights
				for (const entry of map) {
					const targetHeight = entry[1];
					if (targetHeight > heightMax) {
						heightMax = targetHeight;
					}
				}

				// set height of all targets to the same
				for (const entry of map) {
					const $target = entry[0];
					$target.style.height = `${heightMax}px`;
				}
			}
		}
	}

	//

	gather() {
		// release last targets
		const $lastTargets = this.el.targets;
		for (let i = 0; i < $lastTargets.length; i++) {
			const $target = $lastTargets[i];
			$target.style.height = '';
		}

		// create new targets
		this.el.targets = this.el.container.querySelectorAll('[data-height-match-target]');
		this.states.heightMaps = {};

		for (let i = 0; i < this.el.targets.length; i++) {
			const $target = this.el.targets[i];
			const mapId = $target.dataset.heightMatchTarget || 'default';
			let map = this.states.heightMaps[mapId];

			if (!map) {
				this.states.heightMaps[mapId] = new Map();
				map = this.states.heightMaps[mapId];
			}

			map.set($target, 0);
		}
	}

	//

	removeStyles() {
		for (const mapKey in this.states.heightMaps) {
			const map = this.states.heightMaps[mapKey];
			for (const entry of map) {
				const $target = entry[0];
				$target.style.height = '';
			}
		}
	}

	// destroy

	destroy() {
		this.removeStyles();
		this.#removeEventListeners();
	}

}
